import React from 'react';
import LabelWithSymbols from '@common/component/atoms/LabelBySymbols';
import HeadLine from '@common/component/atoms/HeadLine';

export interface ContentProps {
  title: string;
  detail: string;
  titleClassName?: string;
  detailClassName?: string;
}

/**
 * メール受信の承諾画面コンテンツ部
 */
const Content: React.FC<ContentProps> = ({ title, detail, titleClassName, detailClassName }) => {
  return (
    <>
      <HeadLine text={title} className={titleClassName || `md-headline`} data-testid='opt-in-mail-content--accept-title' />
      <LabelWithSymbols text={detail} className={detailClassName || 'md-text'} data-testid='opt-in-mail-content--detail-text' />
    </>
  );
};
export default Content;
